export class AuditLogCloudContext {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "provider",
            "baseName": "provider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogCloudContext.attributeTypeMap;
    }
    constructor() {
    }
}
